export default {
  "content": "<path d=\"M14.625 6.188L9 11.813 3.375 6.186\" stroke=\"var(--Grey-70)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none"
  }
};